import {
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';


function InsurancePremiumDetails({

  customerSelectedOfferData,
  placementSlipData,
  policyDetail = null
}) {
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };


  return (
    <>


      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <div
            style={{
              paddingTop: '0.8%'
            }}
          >
            <Typography
              gutterBottom
              variant="h4"
              className="blockHeader heading"
              component="div"
              style={{
                background: 'rgb(9 84 174)',
                color: '#fff',
                padding: '16px',
                paddingTop: '2px',
                paddingBottom: '2px',
                marginBottom: '3vh'
              }}
            >
              <div
                style={{
                  paddingTop: '0.3%',
                  paddingBottom: '0.3%'
                }}
              >
                Insurance Premium
              </div>
            </Typography>
          </div>
          <Table aria-label="a dense table"
            style={{
              opacity:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insurance_premium_details?.status === 'approve'
                  ? 0.5
                  : 1,
              pointerEvents:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insurance_premium_details?.status === 'approve'
                  ? 'none'
                  : 'auto',
              width: '100%'
            }}>
            <TableBody>
              <TableRow>
                <TableCell
                  style={{
                    width: 600,
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                    paddingLeft: '0px'
                  }}
                >
                  Basic Premium
                </TableCell>
                <TableCell
                  width={300}
                  align="right"
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                    paddingLeft: '0px'
                  }}
                >
                  {
                    Number(
                      placementSlipData?.[0]?.['basicPremium']
                    )?.toFixed(2)
                  }
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                    paddingLeft: '0px'
                  }}
                >
                  Add on Coverage Premium
                </TableCell>
                {customerSelectedOfferData ? (
                  <TableCell
                    align="right"
                    style={{
                      height: '20px',
                      paddingTop: '2px',
                      paddingBottom: '2px',
                      paddingLeft: '0px'
                    }}
                  >
                    {(
                      Number(placementSlipData?.[0]?.['totalPremium']) -
                      Number(placementSlipData?.[0]?.['basicPremium'])
                    )?.toFixed(2) || '0.00'}
                  </TableCell>
                ) : null}
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                    paddingLeft: '0px'
                  }}
                >
                  Total Premium
                </TableCell>
                {
                  <TableCell
                    align="right"
                    style={{
                      height: '20px',
                      paddingTop: '2px',
                      paddingBottom: '2px',
                      paddingLeft: '0px'
                    }}
                  >
                    {placementSlipData?.[0]?.['totalPremium']
                      ? Number(
                        placementSlipData?.[0]?.['totalPremium']
                      ).toFixed(2)
                      : '0.00'}
                  </TableCell>
                }
              </TableRow>

              <TableRow>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                    paddingLeft: '0px'
                  }}
                >
                  GST
                </TableCell>
                <TableCell
                  align="right"
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                    paddingLeft: '0px'
                  }}
                >
                  {
                    Number(placementSlipData?.[0]?.['gstAmount'])?.toFixed(2)
                  }
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                    paddingLeft: '0px'
                  }}
                >
                  Gross Premium
                </TableCell>
                <TableCell
                  align="right"
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                    paddingLeft: '0px'
                  }}
                >
                  {Number(
                    placementSlipData?.[0]?.['grossPremium']
                  )?.toFixed(2)
                  }
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

        </Grid>

      </Grid>
    </>
  );
}

export default InsurancePremiumDetails;
